import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }

    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => navigate("/admin", { state: { user: res.data }, replace: true }))
      .catch(() => navigate("/admin", { replace: true }));
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-[#F6F5F2] flex items-center justify-center font-sans text-sm text-[#5A564F]" data-testid="auth-callback-loading">
      Accesso in corso...
    </div>
  );
}
